export default function CTA() {
  return (
    <section id="cta" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-neutral-900 rounded-3xl p-12 md:p-20 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-[#1E3A8A] rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#1E3A8A] rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
          </div>
          
          <div className="relative z-10">
            <p className="text-sm font-medium text-neutral-300 tracking-wide mb-4">
              LONG ISLAND SMALL BUSINESS SPECIALISTS
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight tracking-tight mb-6">
              Ready to grow
              <br />
              your business?
            </h2>
            
            <p className="text-lg text-neutral-400 max-w-xl mx-auto mb-10">
              Let's discuss how we can help your Long Island business reach more customers with a stunning website and engaging video content.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a 
                href="tel:+16316407888"
                className="inline-flex items-center gap-3 bg-white text-neutral-900 px-8 py-4 rounded-full text-sm font-medium hover:bg-neutral-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-teal-600"></i>
                Call (631) 640-7888
              </a>
              <a 
                href="mailto:info@bellportbranding.com"
                className="bg-transparent border border-neutral-700 text-white px-8 py-4 rounded-full text-sm font-medium hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                info@bellportbranding.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}